import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    editButton: {
      fontWeight: 500,
      textTransform: 'capitalize',
    },
    dialog: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
    },
    dialogContainer: {
      background: theme.palette.background.paper,
      boxShadow: '0px 3px 6px #00000024',
      borderRadius: 4,
      overflow: 'auto',
      maxHeight: '100%',
      maxWidth: 900,
      width: '100%',
      paddingTop: 70,
      paddingBottom: 50,
    },
    dialogTitle: {
      marginTop: 20,
      marginBottom: 20,
      color: theme.palette.primary.main,
      fontFamily: theme.typography.helveticaFont,
      fontWeight: 700,
      fontSize: '1.5rem',
    },
    dialogDescription: {
      marginTop: 10,
      marginBottom: 10,
      fontFamily: theme.typography.helveticaFont,
      fontWeight: 400,
      fontSize: '0.625srem',
      maxWidth: 400,
    },
    dialogNote: {
      fontWeight: 700,
    },
    dialogButtonLeft: {
      marginRight: 50,
      textTransform: 'uppercase',
    },
    dialogButtonRight: {
      marginLeft: 50,
      textTransform: 'uppercase',
    },
    selectField: {
      width: '100%',
    },
    icon: {
      color: theme.palette.primary.main,
      width: '2.5rem',
      height: '2.5rem',
    },
    rowForm: {
      marginTop: 20,
      marginBottom: 20,
    },
  };
});

export default useStyles;
